$(document).on('turbolinks:load', function () {
  const inputs = {
    init: function () {
      const inputs = $('*[data-ui="input"]');
      inputs.each((index, input) => {
        $(input).append('<button class="clear" data-action="clear" />');
      });

      this.listen();
    },

    listen: function () {
      const inputs = $('*[data-ui="input"]');
      inputs.each((index, input) => {
        $(input).on("input", (e) => {
          if (e.target.value.length >= 1) {
            $(input).children(".clear").css({ opacity: 1 });
          } else {
            $(input).children(".clear").css({ opacity: 0 });
          }
        });

        $(input)
          .children('*[data-action="clear"]')
          .on("click", () => {
            $(input).children("input").val("");
            $(input).children("input").trigger("focus");
            $(input).children(".clear").css({ opacity: 0 });
          });
      });
    },
  };

  const suggestions = {
    init: function () {
      const suggestions = $('*[data-ui="suggestions"]');

      suggestions.each((index, suggestions) => {
        $(suggestions)
          .children(".suggestions-item")
          .on("click", (suggestion) => {
            $(suggestion.target).hasClass("active")
              ? $(suggestion.target).removeClass("active")
              : $(suggestion.target).addClass("active");
          });
      });
    },
  };

  inputs.init();
  suggestions.init();

  window.forms = {
    listenInputs: inputs.listen,
    suggestions: suggestions,
  };
});
